// Module
var code = `<div ng-if="\$ctrl.isPermissionMissing()" class="alert alert--danger missing-read-access-message">
  Read access permission '{{\$ctrl.missingAccess}}' must be enabled for this role to be able to properly use the account selection.
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/missing-access-warning/missing-access-warning.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;